import { isMatching, P } from 'ts-pattern'

export const isMatchingT: <A>(pattern: P.Pattern<A>) => (a: A) => boolean =
  isMatching
